import {NgOptimizedImage} from "@angular/common";
import {Component, inject, LOCALE_ID, signal} from "@angular/core";
import {map, type Observable, shareReplay, zip} from "rxjs";
import type {SafeValueResourceRef} from "../../helpers/ResourceHelpers";
import {rxSafeResource} from "../../helpers/ResourceHelpers";
import {HeaderComponent} from "../../layout/header/header.component";
import {ReferenceKind} from "../../models/Reference/Reference";
import {ReferenceLinkKind} from "../../models/Reference/ReferenceLink";
import type {References} from "../../models/Reference/References";
import {SafeHtmlPipe} from "../../pipes/safe-html.pipe";
import {ReferencesService} from "../../services/api/references.service";

@Component({
  selector: "app-projects",
  templateUrl: "./projects.component.html",
  styleUrl: "./projects.component.scss",
  imports: [
    HeaderComponent,
    SafeHtmlPipe,
    NgOptimizedImage,
  ],
})
export class ProjectsComponent {
  protected readonly ReferenceKind = ReferenceKind;
  protected readonly ReferenceLinkKind = ReferenceLinkKind;

  private readonly currentOffset = signal(0);
  protected readonly references: SafeValueResourceRef<References>;

  protected readonly locale = inject(LOCALE_ID);

  public constructor() {
    const referenceService = inject(ReferencesService);
    let lastProjects: Observable<References> | undefined = undefined;
    this.references = rxSafeResource({
      params: () => ({offset: this.currentOffset()}),
      stream: ({params: {offset}}) => {
        const loaded = referenceService.getAllReferences({offset}).pipe(shareReplay(1));
        lastProjects = offset === 0 || !lastProjects ? loaded : zip([lastProjects, loaded]).pipe(
          map(([existing, loaded]) => ({
            entries: existing.entries.concat(loaded.entries),
            total: loaded.total,
          })),
        );
        return lastProjects;
      },
      defaultValue: {entries: [], total: 0},
    });
  }

  protected loadMore(currentLength: number): void {
    this.currentOffset.set(currentLength);
  }
}
